import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isWorldPath } from '../../world/content/paths';

/**
 * Scrolls the window to the top whenever the route pathname changes.
 * Skips the scroll when only the search/hash changes (so deep-link tab
 * switches inside a page can stay where they are).
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // The world owns scroll: it is the camera's input.
    if (isWorldPath(pathname)) return;
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
